var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodBank24DpE8Eaed1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_2326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 3.75L5 11.25V26.25H25V11.25L15 3.75ZM15.625 15.625C15.625 16.6625 14.7875 17.5 13.75 17.5V22.5H12.5V17.5C11.4625 17.5 10.625 16.6625 10.625 15.625V11.875H11.875V15.625H12.5V11.875H13.75V15.625H14.375V11.875H15.625V15.625ZM18.75 22.5H17.5V18.125H16.25V14.375C16.25 13 17.375 11.875 18.75 11.875V22.5Z",
    fill: "#4D4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_2326"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodBank24DpE8Eaed1);
export default __webpack_public_path__ + "static/media/food_bank_24dp_E8EAED 1.edeb925a9450463d8f120d2521c2c435.svg";
export { ForwardRef as ReactComponent };